window.location.replace('https://www.xesmall.com/')
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload, {
  preLoad: 1,
  loading: require("./assets/home/loading.svg"),
  error: require("./assets/home/loading.svg"),
  attempt: 1
});

new Vue({
  data: {},
  router,
  render: (h) => h(App)
}).$mount('#app')
